import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexRow from '@ui/atoms/FlexRow';
import StyledLink from '@ui/atoms/StyledLink';

import aligned from '@ui/styled/Aligned';

import ArrowHalfLeftIcon from '@assets/vectors/icon-arrow-half.inline.svg';

interface IBreadcrumbProps {
	label: string;
	href: string;
}

const AlignedRow = aligned(FlexRow);

const Breadcrumb: FC<IBreadcrumbProps> = ({ href, label }) => {
	return (
		<StyledLink to={href} variant="normal">
			<AlignedRow alignItems="center" gap="xxs">
				<ArrowHalfLeftIcon />
				<BasicText>{label}</BasicText>
			</AlignedRow>
		</StyledLink>
	);
};

export default styled(Breadcrumb)``;
